(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitoniq-plan-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function recommend(answers) {
    if (answers[0] === 'trial') return 2;
    if (answers[0] === 'rhythm') return 4;
    if (answers[0] === 'long') return 8;
    if (answers[2] === 'stopped' || (answers[1] === 'cook' && answers[2] === 'boredom')) return 2;
    return 4;
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { recommend };
  if (typeof document === 'undefined') return;

  function emit(root, event, details) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event, quiz_id: 'fitoniq_plan_finder', quiz_instance: root.dataset.instance }, details || {}));
  }

  function setup(root) {
    if (root.dataset.fnqInitialized) return;
    root.dataset.fnqInitialized = 'true';
    const screens = Array.from(root.querySelectorAll('[data-screen]'));
    const questions = Array.from(root.querySelectorAll('[data-question]'));
    const progress = root.querySelector('[data-progress]');
    const progressLabel = root.querySelector('[data-progress-label]');
    const progressFill = root.querySelector('[data-progress-fill]');
    const back = root.querySelector('[data-back]');
    const cta = root.querySelector('[data-result-cta]');
    const missingPlan = root.querySelector('[data-missing-plan]');
    const form = root.querySelector('.fnq-finder__email-form');
    const storageKey = 'fitoniq-plan-finder:' + root.dataset.instance;
    let answers = [null, null, null, null];
    let step = 0;

    function show(screen) {
      screens.forEach((item) => { item.hidden = item.dataset.screen !== screen; });
      const title = root.querySelector('[data-screen="' + screen + '"] ' + (screen === 'quiz' ? '[data-question]:not([hidden]) [data-question-title]' : screen === 'result' ? '[data-result-title]' : '.fnq-finder__headline'));
      if (title) title.focus({ preventScroll: true });
    }

    function showQuestion(index) {
      step = index;
      questions.forEach((question, i) => {
        question.hidden = i !== index;
        question.querySelectorAll('[data-answer]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.answer === answers[i]));
        });
      });
      progress.setAttribute('aria-valuenow', String(index + 1));
      progressLabel.textContent = 'PASO ' + (index + 1) + ' DE 4';
      progressFill.style.width = ((index + 1) * 25) + '%';
      back.textContent = index === 0 ? '← Inicio' : '← Volver';
      show('quiz');
    }

    function showResult(track) {
      if (answers.some((answer) => !answer)) return;
      const weeks = recommend(answers);
      root.querySelector('[data-weeks]').textContent = String(weeks);
      const plan = root.querySelector('[data-plan="' + weeks + '"]');
      root.querySelectorAll('[data-plan]').forEach((item) => { item.hidden = item !== plan; });
      const url = plan.dataset.url;
      cta.hidden = !url;
      missingPlan.hidden = !!url;
      if (url) cta.href = url;
      show('result');
      if (track) {
        emit(root, 'fitoniq_quiz_complete');
        emit(root, 'fitoniq_quiz_recommendation', { plan_weeks: weeks, flavour_preference: answers[3] });
      }
    }

    root.querySelector('[data-start]').addEventListener('click', () => {
      emit(root, 'fitoniq_quiz_start');
      showQuestion(0);
    });
    questions.forEach((question, index) => {
      question.addEventListener('click', (event) => {
        const button = event.target.closest('[data-answer]');
        if (!button || !question.contains(button)) return;
        answers[index] = button.dataset.answer;
        emit(root, 'fitoniq_quiz_question', { question_number: index + 1 });
        if (index < 3) showQuestion(index + 1);
        else showResult(true);
      });
    });
    back.addEventListener('click', () => { if (step === 0) show('intro'); else showQuestion(step - 1); });
    root.querySelector('[data-restart]').addEventListener('click', () => {
      answers = [null, null, null, null];
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
      show('intro');
    });
    cta.addEventListener('click', () => { emit(root, 'fitoniq_quiz_cta', { plan_weeks: recommend(answers) }); });
    root.querySelectorAll('[data-plan-link]').forEach((link) => {
      link.addEventListener('click', () => { emit(root, 'fitoniq_quiz_cta', { plan_weeks: Number(link.dataset.planWeeks) }); });
    });
    if (form) {
      form.addEventListener('submit', () => { try { sessionStorage.setItem(storageKey, JSON.stringify(answers)); } catch (_) {} });
      if (form.querySelector('.fnq-finder__form-message')) {
        try {
          const saved = JSON.parse(sessionStorage.getItem(storageKey));
          if (Array.isArray(saved) && saved.length === 4 && saved.every(Boolean)) {
            answers = saved;
            showResult(false);
            sessionStorage.removeItem(storageKey);
          }
        } catch (_) {}
      }
    }
  }

  function scan() { document.querySelectorAll('[data-fnq-finder]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
